export class DilutionPAEEquinox {

    idSolution: number;

    titreRow: string;
    unique: string;
    lateral: string;
    demi: string;
    complet: string;

    idSolutionUnique: number;
    idSolutionLateral: number;
    idSolutionDemi: number;
    idSolutionComplet: number;

    rang: number;


    rowDilutionPAEEquinox: RowDilutionPAEEquinox[] = [];
}


export class RowDilutionPAEEquinox {
    rowspan: number = 1;
    cellspan: number = 1;
    cellvalue: string = "";
    classspan: string = "rightMargin";
    zoneApplication: number;
    degreApplication: number;
}
